import { ComponentType, MouseEventHandler, createElement } from 'react';
import { useAuthInterceptor } from './useAuthInterceptor';

interface Clickable {
  onClick?: MouseEventHandler<HTMLElement>;
}

/**
 * Run auth process for guest users before original action
 */
export const withAuth =
  <T extends Clickable = Clickable>(Component: ComponentType<T>) =>
  (props: T) => {
    const interceptor = useAuthInterceptor();
    return createElement(Component, { ...props, ...(props.onClick && { onClick: interceptor(props.onClick) }) });
  };
